import { useNavigate } from 'react-router-dom';

export const useBackNavigation = () => {
  const navigate = useNavigate();
  return () => navigate(-1);
};
